<ng-container *ngIf="!isMobile">
  <div
      class="pagination desktop-pagination d-flex"
      [ngClass]="{
          'justify-content-center': !turnOnTotalPage && !turnOnTotalItem
      }"
  >
      <ng-container *ngIf="turnOnTotalPage">
          <div class="col-auto per-page d-flex">
              <div class="label col-auto">
                  <span>{{ 'paging.001' | translate }}</span>
              </div>
              <select-dropdown
                  class="dropdown-select col"
                  [options]="options"
                  [selected]="selectedValue"
                  (changeSelectedValue)="onChangeSelectedValue($event)"
              ></select-dropdown>
          </div>
      </ng-container>
      <ng-container *ngIf="turnOnPagination">
          <div
              class="col-auto paging d-flex justify-content-center"
              [ngStyle]="{
                  'flex-grow':
                      (turnOnTotalPage &&
                          turnOnPagination &&
                          !turnOnTotalItem) ||
                      (!turnOnTotalPage &&
                          turnOnPagination &&
                          turnOnTotalItem)
                          ? '1'
                          : '0'
              }"
          >
              <pagination-template
                  class="pager"
                  #p="paginationApi"
                  [id]="config.id + ''"
                  [maxSize]="maxSize"
                  (pageChange)="handleOnChangePage($event)"
                  *ngIf="totalPages > 1"
              >
                  <a
                      href="javascript:void(0)"
                      [class.disabled]="p.isFirstPage()"
                      (click)="handleOnChangePage(1)"
                  >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon icon-tabler icon-tabler-chevrons-left"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="#000000"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                      >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M11 7l-5 5l5 5" />
                          <path d="M17 7l-5 5l5 5" />
                      </svg>
                  </a>
                  <a
                      href="javascript:void(0)"
                      [class.disabled]="p.isFirstPage()"
                      (click)="handleOnChangePage(page - 1)"
                  >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon icon-tabler icon-tabler-chevron-left"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          stroke-width="1"
                          stroke="#000000"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                      >
                          <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                          ></path>
                          <path d="M15 6l-6 6l6 6"></path>
                      </svg>
                  </a>

                  <ng-container *ngFor="let page of p.pages; index as i">
                      <!-- case 1: totalPages <= 5 then load all -->
                      <ng-container *ngIf="totalPages <= displaySize">
                          <a
                              href="javascript:void(0)"
                              (click)="p.setCurrent(page.value)"
                              [class.current]="p.getCurrent() === page.value"
                              [ngClass]="
                                  p.getCurrent() === page.value
                                      ? 'on disabled'
                                      : ''
                              "
                              >{{ page.value }}</a
                          >
                      </ng-container>

                      <!-- case 2: when totalPages > 5 -->
                      <ng-container *ngIf="totalPages > displaySize">
                          <!-- case 2.a: when currentPage <= 3(center) then remove last 2 pages -->
                          <ng-container
                              *ngIf="
                                  p.getCurrent() <= centerIndex &&
                                  i < displaySize
                              "
                          >
                              <a
                                  href="javascript:void(0)"
                                  (click)="p.setCurrent(page.value)"
                                  [class.current]="
                                      p.getCurrent() === page.value
                                  "
                                  [ngClass]="
                                      p.getCurrent() === page.value
                                          ? 'on disabled'
                                          : ''
                                  "
                                  >{{ page.value }}</a
                              >
                          </ng-container>

                          <!-- case 2.b: when currentPage > 3(center) and currentPage < totalPages - 1 then remove first page and last page -->
                          <ng-container
                              *ngIf="
                                  p.getCurrent() > centerIndex &&
                                  i > 0 &&
                                  i < maxSize - 1 &&
                                  p.getCurrent() < totalPages - 2
                              "
                          >
                              <a
                                  href="javascript:void(0)"
                                  (click)="p.setCurrent(page.value)"
                                  [class.current]="
                                      p.getCurrent() === page.value
                                  "
                                  [ngClass]="
                                      p.getCurrent() === page.value
                                          ? 'on disabled'
                                          : ''
                                  "
                                  >{{ page.value }}</a
                              >
                          </ng-container>

                          <!-- case 2.c: when last 5 pages but totalPages < 7 then remove first page -->
                          <ng-container
                              *ngIf="
                                  totalPages < maxSize &&
                                  p.getCurrent() >= totalPages - 2 &&
                                  i > 0
                              "
                          >
                              <a
                                  href="javascript:void(0)"
                                  (click)="p.setCurrent(page.value)"
                                  [class.current]="
                                      p.getCurrent() === page.value
                                  "
                                  [ngClass]="
                                      p.getCurrent() === page.value
                                          ? 'on disabled'
                                          : ''
                                  "
                                  >{{ page.value }}</a
                              >
                          </ng-container>

                          <!-- case 2.d: when last 5 pages but totalPages >= 7 then remove first 2 pages -->
                          <ng-container
                              *ngIf="
                                  totalPages >= maxSize &&
                                  p.getCurrent() >= totalPages - 2 &&
                                  i > 1
                              "
                          >
                              <a
                                  href="javascript:void(0)"
                                  (click)="p.setCurrent(page.value)"
                                  [class.current]="
                                      p.getCurrent() === page.value
                                  "
                                  [ngClass]="
                                      p.getCurrent() === page.value
                                          ? 'on disabled'
                                          : ''
                                  "
                                  >{{ page.value }}</a
                              >
                          </ng-container>
                      </ng-container>
                  </ng-container>

                  <a
                      href="javascript:void(0)"
                      [class.disabled]="p.isLastPage()"
                      (click)="handleOnChangePage(page + 1)"
                  >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon icon-tabler icon-tabler-chevron-right"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          stroke-width="1"
                          stroke="#000000"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                      >
                          <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                          ></path>
                          <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                  </a>
                  <a
                      href="javascript:void(0)"
                      [class.disabled]="p.isLastPage()"
                      (click)="handleOnChangePage(totalPages)"
                  >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon icon-tabler icon-tabler-chevrons-right"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="#000000"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                      >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M7 7l5 5l-5 5" />
                          <path d="M13 7l5 5l-5 5" />
                      </svg>
                  </a>
              </pagination-template>
          </div>
      </ng-container>

      <ng-container *ngIf="turnOnTotalItem">
          <div class="col-auto total">
              <span class="label">{{ 'paging.002' | translate }}</span>
              <span class="value lable-total">{{ totalItems }}</span>
          </div>
      </ng-container>
  </div>
</ng-container>

<ng-container *ngIf="isMobile">
  <div class="pagination mobile-pagination row mx-0">
      <div class="col-auto per-page">
          <div class="row form">
              <div class="col-auto">
                  <label class="form-label label"
                      ><span> {{ 'paging.001' | translate }}</span></label
                  >
              </div>
              <select-dropdown
                  class="dropdown-select col"
                  [options]="options"
                  [selected]="selectedValue"
                  (changeSelectedValue)="onChangeSelectedValue($event)"
              ></select-dropdown>
          </div>
      </div>
      <div class="col-auto total">
          <span class="label"> {{ 'paging.002' | translate }}</span>
          <span class="value">{{ totalItems }}</span>
      </div>
  </div>
</ng-container>
